import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    vaccineSupplyChain: {
        id: 'iaso.polio.menu.vaccineSupplyChain',
        defaultMessage: 'Supply chain',
    },
    country: {
        id: 'iaso.polio.table.label.country',
        defaultMessage: 'Country',
    },
    vaccine: {
        id: 'iaso.polio.vaccine',
        defaultMessage: 'Vaccine',
    },
    obrName: {
        id: 'iaso.polio.form.label.obrName',
        defaultMessage: 'OBR Name',
    },
    poNumbers: {
        id: 'iaso.polio.label.poNumbers',
        defaultMessage: 'PO numbers',
    },
    dosesShipped: {
        id: 'iaso.polio.label.dosesShipped',
        defaultMessage: 'Doses shipped',
    },
    dosesReceived: {
        id: 'iaso.polio.label.dosesReceived',
        defaultMessage: 'Doses received',
    },
    dosesRequested: {
        id: 'iaso.polio.label.dosesRequested',
        defaultMessage: 'Doses requested',
    },
    rounds: {
        id: 'iaso.polio.form.label.rounds',
        defaultMessage: 'Rounds',
    },
    roundNumbers: {
        id: 'iaso.polio.form.label.roundNumbers',
        defaultMessage: 'Round number(s)',
    },
    startDate: {
        id: 'iaso.label.dateFrom',
        defaultMessage: 'Start date',
    },
    endDate: {
        id: 'iaso.label.dateTo',
        defaultMessage: 'End date',
    },
    estimatedDateOfArrival: {
        id: 'iaso.polio.label.estimatedDateOfArrival',
        defaultMessage: 'Estimated date of arrival',
    },
    doses_shipped: {
        id: 'iaso.polio.label.dosesShipped',
        defaultMessage: 'Doses shipped',
    },
    vials_shipped: {
        id: 'iaso.polio.label.vialsShipped',
        defaultMessage: 'Vials shipped',
    },
    vials_received: {
        id: 'iaso.polio.label.vialsReceived',
        defaultMessage: 'Vials received',
    },
    actions: {
        defaultMessage: 'Action(s)',
        id: 'iaso.label.actions',
    },
    edit: {
        id: 'iaso.label.edit',
        defaultMessage: 'Edit',
    },
    search: {
        defaultMessage: 'Search',
        id: 'iaso.search',
    },
    RoundStartFrom: {
        id: 'iaso.polio.label.RoundStartFrom',
        defaultMessage: 'Round start date from',
    },
    RoundStartTo: {
        id: 'iaso.polio.label.RoundStartTo',
        defaultMessage: 'Round start date to',
    },
    deleteVRF: {
        id: 'iaso.polio.label.deleteVRF',
        defaultMessage: 'Delete VRF',
    },
    deleteVRFWarning: {
        id: 'iaso.polio.label.deleteVRFWarning',
        defaultMessage:
            'This will also delete all attached pre-alerts and VARs',
    },
    clear: {
        id: 'iaso.label.clear',
        defaultMessage: 'Clear',
    },
    supplyChainStatus: {
        id: 'iaso.polio.label.supplyChainStatus',
        defaultMessage: 'Supply chain status',
    },
    save: {
        id: 'iaso.label.save',
        defaultMessage: 'Save',
    },
    cancel: {
        id: 'iaso.label.cancel',
        defaultMessage: 'Cancel',
    },
    pre_alerts: {
        id: 'iaso.polio.label.PREALERT',
        defaultMessage: 'Pre-alerts',
    },
    arrival_reports: {
        id: 'iaso.polio.label.VAR',
        defaultMessage: 'Vaccines arrival reports',
    },
    vrf: {
        id: 'iaso.polio.label.VRF',
        defaultMessage: 'VRF',
    },
    vrfTitle: {
        id: 'iaso.polio.label.vrfTitle',
        defaultMessage: 'Vaccine request form',
    },
    vrfType: {
        id: 'iaso.polio.label.vrfType',
        defaultMessage: 'Vaccine request form Type',
    },
    vrfTypeNormal: {
        id: 'iaso.polio.label.vrfTypeNormal',
        defaultMessage: 'Normal',
    },
    vrfTypeMissing: {
        id: 'iaso.polio.label.vrfTypeMissing',
        defaultMessage: 'Missing',
    },
    vrfTypeNotRequired: {
        id: 'iaso.polio.label.vrfTypeNotRequired',
        defaultMessage: 'Not Required',
    },
    saveAll: {
        id: 'iaso.polio.label.saveAll',
        defaultMessage: 'Save all',
    },
    createVrf: {
        id: 'iaso.polio.label.createVrf',
        defaultMessage: 'Create VRF',
    },
    markForDeletion: {
        id: 'iaso.polio.label.markForDeletion',
        defaultMessage: 'Mark for deletion',
    },
    cancelDeletion: {
        id: 'iaso.polio.label.cancelDeletion',
        defaultMessage: 'Cancel deletion',
    },
    expirationDate: {
        id: 'iaso.polio.label.expirationDate',
        defaultMessage: 'Expiration date',
    },
    estimated_arrival_time: {
        id: 'iaso.polio.label.estimated_arrival_time',
        defaultMessage: 'Estimated arrival date',
    },
    lot_numbers: {
        id: 'iaso.polio.label.lot_numbers',
        defaultMessage: 'Lot numbers',
    },
    po_number: {
        id: 'iaso.polio.label.po_number',
        defaultMessage: 'PO number',
    },
    date_pre_alert_reception: {
        id: 'iaso.polio.label.date_pre_alert_reception',
        defaultMessage: 'Pre-alert reception',
    },
    doses_received: {
        id: 'iaso.polio.label.doses_received',
        defaultMessage: 'Doses received',
    },
    addPreAlert: {
        id: 'iaso.polio.label.addPreAlert',
        defaultMessage: 'Add pre-alert',
    },
    addVar: {
        id: 'iaso.polio.label.addVar',
        defaultMessage: 'Add VAR',
    },
    arrival_report_date: {
        id: 'iaso.polio.label.arrival_report_date',
        defaultMessage: 'Arrival report date',
    },
    dosesPerVial: {
        id: 'iaso.polio.label.dosesPerVial',
        defaultMessage: 'Doses per vial',
    },
    varsTitle: {
        id: 'iaso.polio.label.varTitle',
        defaultMessage: 'Vaccine arrival reports',
    },
    wastageRatio: {
        id: 'iaso.polio.label.wastageRatio',
        defaultMessage: 'Wastage ratio',
    },
    comments: {
        id: 'iaso.polio.label.comments',
        defaultMessage: 'Comments',
    },
    campaign: {
        id: 'iaso.polio.label.campaign',
        defaultMessage: 'Campaign',
    },
    date_vrf_signature: {
        id: 'iaso.polio.label.date_vrf_signature',
        defaultMessage: 'Date of VRF signature',
    },
    quantities_ordered_in_doses: {
        id: 'iaso.polio.label.quantities_ordered_in_doses',
        defaultMessage: 'Quantity needed in doses',
    },
    date_vrf_reception: {
        id: 'iaso.polio.label.date_vrf_reception',
        defaultMessage: 'Date of VRF reception',
    },
    date_vrf_submission_to_orpg: {
        id: 'iaso.polio.label.date_vrf_submission_to_orpg',
        defaultMessage: 'Date of VRF submission ORPG',
    },
    quantities_approved_by_orpg_in_doses: {
        id: 'iaso.polio.label.quantities_approved_by_orpg_in_doses',
        defaultMessage: 'Quantity approved by ORPG in doses',
    },
    date_rrt_orpg_approval: {
        id: 'iaso.polio.label.date_rrt_orpg_approval',
        defaultMessage: 'Date of RRT/ORPG approval',
    },
    defaultMutationApiError: {
        id: 'iaso.snackBar.error',
        defaultMessage: 'An error occurred while saving',
    },
    defaultMutationApiSuccess: {
        id: 'iaso.snackBar.successful',
        defaultMessage: 'Saved successfully',
    },
    positiveInteger: {
        id: 'iaso.polio.form.validator.error.positiveInteger',
        defaultMessage: 'Please use a positive integer',
    },
    positiveNumber: {
        id: 'iaso.polio.form.validator.error.positiveNumber',
        defaultMessage: 'Please use a positive number',
    },
    invalidDate: {
        id: 'iaso.polio.form.invalidDate',
        defaultMessage: 'Date is invalid',
    },
    doses_per_vial: {
        id: 'iaso.polio.form.doses_per_vial',
        defaultMessage: 'Doses per vial',
    },
    pleaseCreateVrf: {
        id: 'iaso.polio.form.pleaseCreateVrf',
        defaultMessage: 'Create VRF to unlock this tab',
    },
    notAvailableNotNormal: {
        id: 'iaso.polio.form.notAvailableNotNormal',
        defaultMessage: 'Available only if VRF is set as normal',
    },
    arrival_reportsApiSuccess: {
        id: 'iaso.polio.api.arrival_reportsApiSuccess',
        defaultMessage: 'Arrival report(s) sucessfully updated',
    },
    pre_alertsApiSuccess: {
        id: 'iaso.polio.api.pre_alertsApiSuccess',
        defaultMessage: 'Pre-alert(s) sucessfully updated',
    },
    vrfApiSuccess: {
        id: 'iaso.polio.api.vrfApiSuccess',
        defaultMessage: 'VRF sucessfully updated',
    },
    vrfApiError: {
        id: 'iaso.polio.error.vrfApiError',
        defaultMessage: 'Could not update VRF',
    },
    arrival_reportsCreateError: {
        id: 'iaso.polio.error.arrival_reportsCreateError',
        defaultMessage: 'Could not create arrival report(s)',
    },
    arrival_reportsUpdateError: {
        id: 'iaso.polio.error.arrival_reportsUpdateError',
        defaultMessage: 'Could not update arrival report(s)',
    },
    arrival_reportsDeleteError: {
        id: 'iaso.polio.error.arrival_reportsDeleteError',
        defaultMessage: 'Could not delete arrival report(s)',
    },
    pre_alertsCreateError: {
        id: 'iaso.polio.error.pre_alertsCreateError',
        defaultMessage: 'Could not create pre-alert(s)',
    },
    pre_alertsUpdateError: {
        id: 'iaso.polio.error.pre_alertsUpdateError',
        defaultMessage: 'Could not update pre-alert(s)',
    },
    pre_alertsDeleteError: {
        id: 'iaso.polio.error.pre_alertsDeleteError',
        defaultMessage: 'Could not delete pre-alert(s)',
    },
    lotNumberError: {
        id: 'iaso.polio.form.error.lotNumberError',
        defaultMessage: 'Please input numbers separated by a comma',
    },
    requiredField: {
        id: 'iaso.forms.error.fieldRequired',
        defaultMessage: 'This field is required',
    },
    countryBlock: {
        defaultMessage: 'Country block',
        id: 'iaso.polio.label.countryBlock',
    },
    campaignCategory: {
        id: 'iaso.polio.label.campaignCategory',
        defaultMessage: 'Campaign category',
    },
    cancelChanges: {
        id: 'iaso.polio.label.cancelChanges',
        defaultMessage: 'Cancel changes',
    },
    targetPopulation: {
        id: 'iaso.polio.label.targetPopulation',
        defaultMessage: 'Target population',
    },
    document: {
        id: 'iaso.polio.label.document',
        defaultMessage: 'Document',
    },
    uniquePoNumberWarning: {
        id: 'iaso.polio.label.uniquePoNumberWarning',
        defaultMessage: 'This PO number is already in use',
    },
    PoNumberNoPrefix: {
        id: 'iaso.polio.label.PoNumberNoPrefix',
        defaultMessage: 'Please input PO number without prefix',
    },
    vrfCreatedAt: {
        id: 'iaso.polio.label.vrfCreatedAt',
        defaultMessage: 'VRF created',
    },
    see: {
        defaultMessage: 'See',
        id: 'iaso.label.see',
    },
});

export default MESSAGES;
